import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getEduSubjectList } from "./edusubjectApi";

const defaultState = {
    subjectList: [],
    isLoaded: false,
    isLoading: false
}
export const fetchEduSubjectApi = createAsyncThunk('edusubject/loadallsubjects', async () => {
    const subjectList = await getEduSubjectList();
    return subjectList;
});
const EduSubjectSlice = createSlice({
    name: 'edusubjects',
    initialState : defaultState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchEduSubjectApi.pending, (state) => {
                state.isLoading = true;
                state.isLoaded = false;
            })
            .addCase(fetchEduSubjectApi.fulfilled, (state, action) => {
                state.subjectList = action.payload;
                state.isLoading = false;
                state.isLoaded = true;
            })
            .addCase(fetchEduSubjectApi.rejected, (state) => {
                state.isLoading = false;
                state.isLoaded = false;
            });
           
    }
});
export const { eduSubjects } = EduSubjectSlice.actions;
export default EduSubjectSlice.reducer;